import { PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808 } from "@faire/web-api/indigofair/settings/PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingProductCustomizationsBuildathon = (): boolean =>
  useSetting(PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808, false);

export const useAssignSettingProductCustomizationsBuildathon = () =>
  useAssignSetting(PRODUCT_CUSTOMIZATIONS_BUILDATHON_240808);
